<template>
   <div>
      <ConfirmDialog />
      <div class="min-h-screen flex flex-column" style="width: 100vw">
         <div class="flex flex-row w-full align-items-center zeta-index">
            <Sidebar v-model:visible="visible" :header="avatarData.email">
               <div class="flex flex-column h-full justify-content-between">
                  <div>
                     <PanelMenu
                        :model="items"
                        multiple
                        :pt="{
                           headerContent: {
                              style: {
                                 backgroundColor: 'white',
                              },
                           },
                           headericon: {
                              style: {
                                 color: '#3B82F6',
                              },
                           },
                           icon: {
                              style: {
                                 color: '#3B82F6',
                              },
                           },
                           menucontent: {
                              style: {},
                           },
                           submenuicon: {
                              style: {
                                 color: '#3B82F6',
                              },
                           },
                        }"
                     />
                  </div>
                  <div>
                     <Button
                        icon="pi pi-sign-out"
                        @click="confirmLogout"
                        label="Log Out"
                        class="w-full"
                        severity="secondary"
                        outlined
                     />
                  </div>
               </div>
            </Sidebar>
            <div
               class="flex flex-row w-full align-items-center justify-content-between p-5 h-5rem"
            >
               <div class="flex flex-row w-full align-items-center">
                  <Skeleton
                     v-show="isLoading"
                     width="10rem"
                     height="3rem"
                     borderRadius="16px"
                     class="mr-6"
                  />

                  <img
                     v-show="!isLoading"
                     :src="companyLogo"
                     alt="Image"
                     class="mr-0 lg:mr-6"
                  />
                  <div class="show-menu-items">
                     <Menubar :model="items" style="border: none" />
                  </div>
               </div>

               <div class="flex align-items-center">
                  <NotificationBell v-if="canSeeParNotifications" />
                  <Avatar
                     :label="avatarData.iniciales"
                     size="medium"
                     class="mr-1"
                     style="background-color: #dee9fc; color: #1a2551"
                     v-tooltip.bottom="avatarData.email"
                  />
                  <Button
                     class="show-button"
                     icon="pi pi-bars"
                     @click="visible = true"
                     text
                  />
                  <Button
                     class="show-button-logout"
                     icon="pi pi-sign-out"
                     @click="confirmLogout"
                     text
                  />
               </div>
            </div>
         </div>
         <div
            class="flex flex-column flex-auto px-5 pb-5"
            style="height: calc(100vh - 5rem); min-height: 0"
         >
            <AppBreadcrumb v-if="showBreadcrumb" />
            <div
               class="router-view grow-1"
               :class="{ 'centered-view': centerView }"
            >
               <router-view />
            </div>
         </div>
      </div>
      <Button
         class="floating-support-btn"
         @click="showSupport = true"
      >
         <i
            :class="isNuevaMutual ? 'pi pi-phone' : 'pi pi-question-circle'"
            style="font-size: 2rem"
         ></i>
      </Button>
      <Dialog
         v-model:visible="showSupport"
         header="Contactos Comerciales"
         :modal="true"
         :closable="true"
         :style="{ width: '370px', borderRadius: '12px' }"
      >
         <div class="contact-modal-content">
            <template v-if="isNuevaMutual">
               <div class="contact-section">
                  <div class="contact-label">
                     <i class="pi pi-phone" style="margin-right: 6px" />
                     Teléfonos
                  </div>
                  <div class="contact-info mt-2">
                     <a href="tel:3492602140" class="contact-link"
                        >3492-602140</a
                     >
                     <Button
                        icon="pi pi-copy"
                        class="copy-btn"
                        @click="copyToClipboard('3492-602140')"
                        text
                        rounded
                        size="small"
                        v-tooltip.bottom="'Copiar número'"
                     />
                  </div>
                  <div class="contact-info mt-2">
                     <a href="tel:08008886838" class="contact-link"
                        >0800-888-6838</a
                     >
                     <Button
                        icon="pi pi-copy"
                        class="copy-btn"
                        @click="copyToClipboard('0800-888-6838')"
                        text
                        rounded
                        size="small"
                        v-tooltip.bottom="'Copiar número'"
                     />
                  </div>
               </div>
            </template>
            <template v-else>
               <div class="contact-section">
                  <div class="contact-label">
                     <i class="pi pi-user" style="margin-right: 6px" />
                     Juan Manuel Allassia
                  </div>
                  <div class="contact-info mt-2">
                     <i
                        class="pi pi-whatsapp"
                        style="margin-right: 6px; font-size: 1.2rem"
                     />
                     <a
                        :href="'https://wa.me/5493492302306'"
                        class="contact-link"
                        target="_blank"
                        rel="noopener"
                        >5493492 302306</a
                     >
                     <Button
                        icon="pi pi-copy"
                        class="copy-btn"
                        @click="copyToClipboard('5493492302306')"
                        text
                        rounded
                        size="small"
                        v-tooltip.bottom="'Copiar número'"
                     />
                  </div>
               </div>
               <div class="contact-section">
                  <div class="contact-label">
                     <i class="pi pi-user" style="margin-right: 6px" />
                     Cristian Horny
                  </div>
                  <div class="contact-info mt-2">
                     <i
                        class="pi pi-whatsapp"
                        style="margin-right: 6px; font-size: 1.2rem"
                     />
                     <a
                        :href="'https://wa.me/5493584360539'"
                        class="contact-link"
                        target="_blank"
                        rel="noopener"
                        >5493584360539</a
                     >
                     <Button
                        icon="pi pi-copy"
                        class="copy-btn"
                        @click="copyToClipboard('5493584360539')"
                        text
                        rounded
                        size="small"
                        v-tooltip.bottom="'Copiar número'"
                     />
                  </div>
               </div>
            </template>
            <div class="contact-section">
               <div class="contact-label">
                  <i class="pi pi-envelope" style="margin-right: 6px" />
                  Consultas Generales
               </div>
               <div class="contact-info mt-2">
                  <a
                     href="mailto:consultas@bertolaccini.com"
                     class="contact-link"
                     >consultas@bertolaccini.com</a
                  >
                  <Button
                     icon="pi pi-copy"
                     class="copy-btn"
                     @click="copyToClipboard('consultas@bertolaccini.com')"
                     text
                     rounded
                     size="small"
                     v-tooltip.bottom="'Copiar email'"
                  />
               </div>
            </div>
         </div>
      </Dialog>

      <!-- Modal para carga de productos -->
      <Dialog
         v-model:visible="showProductosDialog"
         header="Cargar Productos"
         :modal="true"
         :closable="true"
         :style="{ width: '30vw', borderRadius: '12px' }"
      >
         <div class="productos-upload-content">
            <div class="upload-section">
               <label class="upload-label" for="empresaProductos">
                  Empresa
               </label>
               <Dropdown
                  id="empresaProductos"
                  v-model="selectedEmpresaProductos"
                  :options="empresasProductos"
                  optionLabel="nombre"
                  optionValue="id_empresa"
                  placeholder="Seleccione empresa"
                  class="w-full mb-3"
               />
               <label class="upload-label">
                  <i class="pi pi-upload" style="margin-right: 8px"></i>
                  Seleccionar archivo de productos
               </label>
               <div class="upload-wrapper">
                  <FileUpload
                     mode="basic"
                     name="filess"
                     accept=".csv"
                     :maxFileSize="10000000"
                     :auto="true"
                     chooseLabel="Seleccionar archivo"
                     customUpload
                     class="w-full"
                     @uploader="onProductosUpload"
                     :disabled="!selectedEmpresaProductos || isLoadingProductos"
                  />
                  <i
                     v-if="isLoadingProductos"
                     class="pi pi-spin pi-spinner upload-spinner"
                  />
               </div>
               <small class="upload-help">
                  Formatos permitido: CSV (.csv).
               </small>
            </div>
         </div>
      </Dialog>
   </div>
</template>

<script setup>
import useAuth from '@/modules/auth/composables/useAuth';
import { useRouter, useRoute } from 'vue-router';
import useNavbar from '@/composables/useNavbar';
import { computed, onMounted, ref, watch } from 'vue';
import store from '@/store';
import { useConfirm } from 'primevue/useconfirm';
import {
   mensajeError,
   mensajeErrorDetalle,
   mensajeExitoDetalle,
} from '@/composables/mensajesSwal';
import {
   escapeHtml,
   buildErroresListHtml,
   buildResumenCargaHtml,
} from '@/helpers/csvErrors';
import AppBreadcrumb from '@/components/AppBreadcrumb.vue';
import NotificationBell from '@/components/NotificationBell.vue';
import { showDemo, showError, showInfo, showSuccess } from '@/composables/useToast';
import { useContextualLogo } from '@/composables/useContextualLogo';

const confirm = useConfirm();
const { logout } = useAuth();
const router = useRouter();
const route = useRoute();
const isLoading = computed(() => store.state.main.isLoading);
const {
   items,
   visible,
   showProductosDialog,
   cargarManuales,
} = useNavbar();
useContextualLogo();
const companyLogo = computed(() => store.state.main.companyIconBase64);
const isLoadingProductos = ref(false);
const empresasProductos = ref([]);
const selectedEmpresaProductos = ref(null);

// Mostrar breadcrumb solo cuando requiresLayout es true y no es la ruta del menú
const showBreadcrumb = computed(() => {
   const routeName = route.name;
   const excludedRoutes = ['menu', 'login', 'recover-password'];
   return (
      route.meta?.requiresLayout === true &&
      routeName &&
      !excludedRoutes.includes(routeName)
   );
});

const centerView = computed(
   () =>
      router.currentRoute.value.name === 'menu' ||
      router.currentRoute.value.name === 'agro/opciones' ||
      router.currentRoute.value.name === 'agro/pago' ||
      router.currentRoute.value.name === 'cliente/alta' ||
      router.currentRoute.value.path.startsWith('/multicotizador/art'),
);
const avatarData = computed(() => {
   const usuario = store.state.auth.usuario?.usuario || '';
   const email = store.state.auth.usuario?.email || '';

   const partes = usuario.split(' ');
   const iniciales =
      partes.length > 1
         ? partes[0].charAt(0).toUpperCase() + partes[1].charAt(0).toUpperCase()
         : partes[0]?.charAt(0).toUpperCase() || '';

   return {
      email,
      iniciales,
   };
});

const canSeeParNotifications = computed(() => {
   const u = store.state.auth.usuario;
   if (!u) return false;
   const isBsa = Number(u.id_empresa) === 20;
   const isGp =
      Number(u.id_grupo) === 1 &&
      (Number(u.nivel) === 1 || Number(u.nivel) === 2);
   return isBsa || isGp;
});

const confirmLogout = () => {
   confirm.require({
      message: '¿Estás seguro de que deseas cerrar sesión?',
      header: 'Confirmar Cierre de Sesión',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sí, salir',
      rejectLabel: 'Cancelar',
      rejectClassName: 'p-button-danger',
      accept: () => {
         logout();
         router.push({ name: 'login' });
      },
      reject: () => {},
   });
};

// Log out function
const onLogOut = () => {
   logout();
   router.push({ name: 'login' });
};

const showSupport = ref(false);

const isNuevaMutual = computed(
   () => Number(store.state.auth.usuario?.id_empresa) === 103,
);

function copyToClipboard(text) {
   navigator.clipboard.writeText(text);
}

const loadEmpresasProductos = async () => {
   try {
      empresasProductos.value = await store.dispatch('bsa/getEmpresas');
   } catch (error) {
      showError('No es posible cargar las empresas');
   }
};

watch(showProductosDialog, (visible) => {
   if (visible) {
      selectedEmpresaProductos.value = null;
      if (empresasProductos.value.length === 0) {
         void loadEmpresasProductos();
      }
   }
});

const onProductosUpload = async (event) => {
   if (!selectedEmpresaProductos.value) {
      mensajeError('Seleccione una empresa antes de cargar el archivo.');
      return;
   }
   isLoadingProductos.value = true;
   showInfo('Cargando productos...');
   const formData = new FormData();
   event.files.forEach((file) => {
      formData.append('files', file);
   });
   formData.append('id_empresa', selectedEmpresaProductos.value);
   try {
      const response = await store.dispatch('bsa/uploadProducts', formData);
      showProductosDialog.value = false;
      mensajeExitoDetalle('Carga completada', buildResumenCargaHtml(response));
   } catch (error) {
      const data = error.response?.data;
      if (data?.errores?.length) {
         mensajeErrorDetalle(
            escapeHtml(data.message) || 'El archivo contiene errores de formato.',
            buildErroresListHtml(data.errores),
         );
      } else {
         mensajeError(
            'Hubo un error al subir el archivo. Contactese con sistemas',
            data?.message,
         );
      }
   } finally {
      isLoadingProductos.value = false;
   }
};

onMounted(() => {
   showDemo();
   void cargarManuales();
});
</script>

<style scoped>
.router-view {
   display: flex;
   justify-content: center;
   flex-grow: 1;
   border-width: 1px;
   border-style: solid;
   border-color: var(--surface-border, #dfe7ef);
   border-radius: 0.5rem;
   background-color: var(--surface-section, #ffffff);
   padding: 1rem;
   overflow-y: auto;
   overflow-x: hidden;
   min-height: 0;
}

.show-button {
   display: none;
}
.show-menu-items {
   display: flex;
}
.show-button-logout {
   display: flex;
}
.zeta-index {
   z-index: 11;
}

@media (max-width: 768px) {
   .router-view {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      padding: 0.5rem;
      padding-top: 50px;
      height: 100px;
   }
   .show-button {
      display: flex;
   }
   .show-menu-items {
      display: none;
   }
   .show-button-logout {
      display: none;
   }
}

.centered-view {
   align-items: center !important; /* Se aplica solo en MenuView */
   overflow-y: auto;
   overflow-x: hidden;
   min-height: 0;
}

.floating-support-btn {
   position: fixed;
   bottom: 24px;
   right: 24px;
   z-index: 9999;
   background-color: rgba(0, 110, 255, 0.253) !important;
   color: rgb(73, 100, 255);
   border: none;
   border-radius: 50%;
   width: 56px;
   height: 56px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
   display: flex;
   align-items: center;
   justify-content: center;
}

.contact-modal-content {
   display: flex;
   flex-direction: column;
   gap: 1.2rem;
   padding: 0.5rem 0.2rem;
}
.contact-section {
   background: #f6f8fa;
   border-radius: 8px;
   padding: 0.7rem 1rem;
   box-shadow: 0 1px 4px rgba(60, 60, 60, 0.04);
}
.contact-label {
   font-weight: 600;
   font-size: 1.05rem;
   margin-bottom: 0.2rem;
   color: #1a2551;
   display: flex;
   align-items: center;
}
.contact-info {
   display: flex;
   align-items: center;
   gap: 0.5rem;
   font-size: 1rem;
   color: #374151;
}
.copy-btn {
   margin-left: 0.3rem;
   color: #2563eb;
}
.contact-link {
   color: #1a2551 !important;
   text-decoration: none !important;
   font-weight: 500;
   transition: color 0.2s;
}
.contact-link:hover {
   color: #1d4ed8 !important;
}

/* Estilos para el modal de productos */
.productos-upload-content {
   padding: 1rem 0;
}

.upload-section {
   display: flex;
   flex-direction: column;
   gap: 1rem;
}

.upload-label {
   font-weight: 600;
   font-size: 1.1rem;
   color: #1a2551;
   display: flex;
   align-items: center;
   margin-bottom: 0.5rem;
}

.upload-help {
   color: #6b7280;
   font-size: 0.9rem;
   margin-top: 0.5rem;
}

.upload-wrapper {
   display: flex;
   align-items: center;
   gap: 0.75rem;
}

.upload-spinner {
   font-size: 1.3rem;
   color: #6b7280;
}
</style>
